import React from 'react';

const PageHeader = ({ icon: Icon, title, bannerImage }) => {
  const isDonationPage = title === '장기기증';
  const isTransportCenter = title === '병원이송센터';
  const isDaycarePage = title === '주간이용시설';
  const isHopeCenter = title === '희망센터';
  const isGreetingPage = title === '인사말';
  const isKidneyOverview = title === '신장질환 d개요';
  const isSimplePage =
    title === '연혁' ||
    title === '조직도' ||
    title === '오시는 길' ||
    title === '신장질환 개요' ||
    title === '신대체요법' ||
    title === '울산광역시 인공신장실' ||
    title === '센터 소식 작성' ||
    title === '신장장애인 복지정보' ||
    title === '행사 및 일정' ||
    title === '공지사항' ||
    title === '센터 소식 작성' ||
    title === '공지사항 작성' ||
    title === '아름다운 동행 소식지';

  return (
    <div className="w-full lg:max-w-[75rem] 2xl:max-w-layout">
      <div className="flex items-center mb-4">
        {isKidneyOverview ? (
          <img
            className="w-24 h-24 object-contain mr-2"
            src="/images/newIcons/6.png"
            alt="로고"
          />
        ) : isTransportCenter ? (
          <img
            className="w-24 h-24 object-contain mr-2"
            src="/images/transport/icon2.png"
            alt="로고"
          />
        ) : isDaycarePage ? (
          <img
            className="w-24 h-24 object-contain mr-2"
            src="/images/icons/logo3.png"
            alt="로고"
          />
        ) : isHopeCenter ? (
          <img
            className="w-24 h-24 object-contain mr-2"
            src="/images/icons/logo.png"
            alt="로고"
          />
        ) : (
          Icon && <Icon className="sm:text-3xl lg:text-5xl mr-4" />
        )}
        <h1 className="sm:text-2xl lg:text-2xl 2xl:text-3xl font-bold text-gray-800 font-notoSans whitespace-nowrap">
          {title}
        </h1>
      </div>
      {!isGreetingPage && !isSimplePage && (
        <div className="w-full">
          <img
            src={bannerImage}
            alt={`${title} 배너 이미지`}
            className={`w-full ${
              isDonationPage
                ? 'sm:h-[300px] md:h-[700px] lg:h-full'
                : 'sm:h-full md:h-[600px] lg:h-full object-cover'
            } rounded-2xl border border-gray-200 object-cover`}
          />
        </div>
      )}
    </div>
  );
};

export default PageHeader;
